import type { FC, ReactNode } from "react";
import { Body } from "../../Typography/Body";
import "./TimelineItemRibbon.css";

export type RibbonVariant = "favorite" | "important";

interface RibbonProps {
  label: string;
  icon: ReactNode;
  variant: RibbonVariant;
  ariaLabel?: string;
}

/**
 * Ribbon — a horizontal tab attached to the top-left of a TimelineItem
 * card. Used to surface at-a-glance status indicators (e.g. Important,
 * Low confidence split). The tab sits above the card edge like a folder
 * label.
 */
export const TimelineItemRibbon: FC<RibbonProps> = ({
  label,
  icon,
  variant,
  ariaLabel,
}) => (
  <div
    className={`indigo-timeline-item__ribbon indigo-timeline-item__ribbon--${variant}`}
    aria-label={ariaLabel ?? label}
  >
    <span className="indigo-timeline-item__ribbon-icon">{icon}</span>
    <Body size="sm" className="indigo-timeline-item__ribbon-text">
      {label}
    </Body>
  </div>
);
